// import momentjs from 'momentjs'
import extend from 'lodash/extend'

function makeArray(e, t) {
  return Array.prototype.slice.call(e, t)
}

  let
      localWindow = window,
      Constr   = function() {
        this.startTime = (new Date).getTime();
        this.verbose   = true;
      },
      log;

  extend(Constr.prototype, {
    setVerbose: function(verbose) {
      return this.verbose = verbose;
    },
    timeElapsed: function(time) {
      // return time.unshift("[" + momentjs().format("DD.MM.YY H:mm:ss") + " " + (((new Date).getTime() - this.startTime) / 1e3).toFixed(3) + "]"),
      //   time;
      return time
    },
    out: function(e, t) {
      if (!localWindow.console)
        return false;
      if (!localWindow.console[e]) {
        if (!localWindow.console.log)
          return false;
        e = "log"
      }
      return localWindow.console[e].apply(localWindow.console, t)
    },
    print: function() {
      if (!this.verbose)
        return this;
      var e = makeArray(arguments);
      return this.out("log", this.timeElapsed(e)),
        this
    },
    warn: function() {
      var e = makeArray(arguments);
      return this.out("warn", this.timeElapsed(e)),
        this
    },
    info: function() {
      var e = makeArray(arguments);
      return this.out("info", this.timeElapsed(e)),
        this
    },
    error: function() {
      var e = makeArray(arguments);
      return this.out("error", this.timeElapsed(e)),
        this
    },
    trace: function() {
      var e = makeArray(arguments);
      return this.out("trace", this.timeElapsed(e)),
        this
    }
  });

  log = new Constr;

export default log;